<template>
  <div class="w-full flex bg-white ml-1 my-2 height-100 border-round">
    <div class="grid grid-cols-7 gap-8 items-center mt-2 h-32 p-4">
      <div class="cursor-pointer" @click="handleClick('ebanner')">
        <img src="@/assets/images/frag.png" class="" alt="banhf" />
      </div>
      <div class="cursor-pointer" @click="handleClick('ebannertwo')">
        <img src="@/assets/images/frag2.png" class="" alt="banhf" />
      </div>
      <div class="cursor-pointer" @click="handleClick('email')">
        <img src="@/assets/images/frag3.png" class="" alt="banhf" />
      </div>
      <div class="cursor-pointer" @click="handleClick('')">
        <img src="@/assets/images/frag4.png" class="" alt="banhf" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
